(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(3230);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);


const Header = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: "Christmas Advent Calendar"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                href: "images/favicon.ico"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: "Christmas advent calendar activities for you to enjoy."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: "https://xmascal.netlify.com/images/family.png"
            })
        ]
    });


/***/ }),

/***/ 8234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "bd": function() { return /* binding */ categories; },
  "gx": function() { return /* binding */ getEmoji; },
  "z9": function() { return /* binding */ getItemsFromCategory; }
});

;// CONCATENATED MODULE: ./data/en.ts
const kitchenList = [
    "Make homemade chocolate truffles",
    "Prepare Christmas cupcakes",
    "Make fruit skewers coated in chocolate",
    "Concoct a spicy pumpkin soup",
    "Decorated ginger and cinnamon biscuits",
    "Spiced mulled wine",
    "White chocolate and cranberry truffles",
    "Christmas shortbread cookies",
    "Christmas sugar cane and spice lemonade",
    "Christmas fruit punch",
    "Individual Christmas puddings",
    "Hot chocolates (optional: peppermint-flavored)",
    "Apple and cinnamon tartlets",
    "Christmas smoothie bowl with red fruits and granola",
    "Cranberry jam Swiss roll",
    "Christmas spiced tea (masalai chai)",
    "Hot apple juice cocktail",
    "Soft gingerbread",
    "Chocolate and mint mousse",
    "Chocolates filled with marzipan",
    "Hot cider punch",
    "Cinnamon star biscuits",
    "Non-alcoholic festive Christmas mocktail",
    "Make s’mores",
    "Host a Christmas crepe night"
];
const outingsList = [
    "Participate in a Christmas cookie decorating workshop",
    "Watch a Christmas classic with family (movie or cartoon)",
    "Host a special Christmas board game night",
    "Have a tree decorating session with music and fairy lights",
    "Write letters to Santa Claus and post them",
    "Have a pajama party watching photos or videos of past Christmases",
    "Take a photo with Santa Claus",
    "Prepare a Christmas song playlist and organize a home karaoke session",
    "Go on a night walk to admire the Christmas lights in the neighborhood",
    "Prepare personalized gift packages with original paper and ribbons",
    "Do a Christmas puzzle with family",
    "Buy a Christmas scratch ticket",
    "Organize a 'Secret Santa' gift exchange",
    "Participate in a toy drive",
    "Book or go see a Christmas show",
    "Make Christmas wreaths with branches and natural decorations",
    "Go ice skating in an outdoor or indoor rink",
    "Go to the cinema to watch a movie",
    "Prepare and distribute homemade cookies to neighbors",
    "Have a Christmas storytelling evening around a fire or under a blanket",
    "Organize a themed Christmas meal with traditional dishes",
    "Have a photo session dressed as elves or reindeer",
    "Attend a Christmas mass or carol concert",
    "Visit a Christmas market",
    "Create a scrapbook or a photo album of Christmas celebrations"
];
const moviesList = [
    "Frozen",
    "Klaus",
    "Home Alone",
    "The Snowman",
    "Love Actually",
    "The Holiday",
    "Elf",
    "The Nightmare Before Christmas",
    "The Christmas Chronicles",
    "The Grinch",
    "The Muppet Christmas Carol",
    "Beauty and the Beast: The Enchanted Christmas",
    "The Family Stone",
    "Mickey's Christmas Carol",
    "A Christmas Carol",
    "The Book of Life",
    "The Ice Princess",
    "The House of Magic",
    "The Star",
    "Snowtime!",
    "Little Vampire",
    "Santa Claus Is Comin' to Town",
    "Coco",
    "Miracle on 34th Street",
    "Jingle All the Way"
];
const craftsList = [
    "Make paper decorations for the Christmas tree",
    "Create personalized greeting cards to send to family and friends",
    "Craft salt dough ornaments to decorate the house",
    "Write the Christmas menu",
    "Make scented candles to create a warm atmosphere",
    "Create a homemade advent calendar with little boxes or pouches",
    "Craft Christmas wreaths with branches, berries, and ribbons",
    "Paint pebbles to make small Christmas characters",
    "Make finger puppets for Christmas storytelling",
    "Make paper stars to hang in the house",
    "Create paper snowflakes for wall decoration",
    "Make reindeer or elf masks for dress-up play",
    "Craft felt Christmas stockings and decorate them",
    "Create origami decorations for the tree or to hang",
    "Make Christmas magnets with magnets and festive images",
    "Create Christmas lanterns with glass jars and LED candles",
    "Create place cards for the festive table",
    "Craft snowmen with socks and rice",
    "Make pine cone wreaths and decorate them",
    "Bake dried oranges in the oven for home decoration",
    "Craft gingerbread men from decorative cardboard",
    "Make felt decorations to hang in the house",
    "Create personalized Christmas ornaments with photos or glitter",
    "Create miniature cardboard villages for a Christmas scene",
    "Make DIY gifts for loved ones (candles, lip balms, etc.)"
];
const hyggeList = [
    "Prepare tea or hot chocolate and enjoy it with a good book",
    "Create a cozy corner with cushions, blankets, and candles for a relaxing evening",
    "Take a walk in the forest or park to enjoy the winter nature",
    "Cook a comforting and friendly dish to share with family or friends",
    "Do a meditation or yoga session to relax and refocus",
    "Take a family photo in front of the Christmas tree, with optional props and costumes",
    "Organize an afternoon of board games by the fire or candlelight",
    "Make homemade Christmas decorations to add a personal touch to your interior",
    "Take a relaxing bath with scented bath salts and soft music",
    "Prepare a tasting platter of homemade cookies to share with loved ones",
    "Light scented candles and listen to soothing music to create a warm atmosphere",
    "Create a gratitude list to reflect on the small joys of the season",
    "Make handmade gifts for your loved ones",
    "Watch Christmas 'fails' on YouTube for a laugh",
    "Write letters to friends or family",
    "Have a relaxing painting or coloring session to unleash creativity",
    "Prepare a hearty brunch and enjoy a convivial moment with family",
    "Do a relaxation session with breathing exercises and stretching",
    "Listen to a relaxing podcast or show while doing a manual activity",
    "Organize an indoor picnic with cozy cushions and blankets",
    "Watch a cozy movie or series alone or with family",
    "Take a break in the day to mindfully enjoy a cup of tea or coffee",
    "Create a playlist of soothing music for your relaxation moments",
    "Take a stroll in the neighborhood to admire the Christmas light decorations",
    "Spend quality time with your loved ones, sharing simple but precious moments"
];

;// CONCATENATED MODULE: ./data/fr.ts
const kitchenListFR = [
    "Faire des truffes au chocolat maison",
    "Pr\xe9parer des cupcakes de No\xebl",
    "R\xe9aliser des brochettes de fruits enrob\xe9s de chocolat",
    "Concocter une soupe de potiron \xe9pic\xe9e",
    "Biscuits de gingembre et cannelle d\xe9cor\xe9s",
    "Vin chaud \xe9pic\xe9",
    "Truffes au chocolat blanc et canneberges",
    "Sabl\xe9s de No\xebl",
    "Limonade de No\xebl \xe0 la canne \xe0 sucre et aux \xe9pices",
    "Punch de No\xebl aux fruits",
    "Petits puddings de No\xebl individuels",
    "Chocolats chauds (optionnel: aromatis\xe9s \xe0 la menthe poivr\xe9e)",
    "Tartelettes aux pommes et cannelle",
    "Smoothie bowl de No\xebl avec des fruits rouges et granola",
    "G\xe2teau roul\xe9 \xe0 la confiture de cranberries",
    "Th\xe9 de No\xebl aux \xe9pices (masalai chai)",
    "Cocktail de jus de pomme chaud",
    "Pain d'\xe9pices moelleux",
    "Mousse au chocolat et \xe0 la menthe",
    "Chocolats fourr\xe9s \xe0 la p\xe2te d'amande",
    "Punch de cidre chaud",
    "Biscuits \xe9toiles \xe0 la cannelle",
    "Cocktail de No\xebl sans alcool (mocktail) festif",
    "Faire des s’mores",
    "Faire une soir\xe9e cr\xe8pes de No\xebl"
];
const outingsListFR = [
    "Participer \xe0 un atelier de d\xe9coration de biscuits de No\xebl",
    "Regarder un classique de No\xebl en famille (film ou dessin anim\xe9)",
    "Organiser une soir\xe9e jeux de soci\xe9t\xe9 sp\xe9ciale No\xebl",
    "Faire une s\xe9ance de d\xe9coration de sapin en musique et avec des guirlandes lumineuses",
    "\xc9crire des lettres au P\xe8re No\xebl et les poster",
    "Faire une soir\xe9e pyjama en regardant des photos ou vid\xe9os de No\xebls pass\xe9s",
    "Prendre une photo avec un P\xe8re No\xebl",
    "Pr\xe9parer une playlist de chansons de No\xebl et organiser une s\xe9ance de karaok\xe9 \xe0 la maison",
    "Faire une randonn\xe9e nocturne pour admirer les lumi\xe8res de No\xebl dans le quartier",
    "Pr\xe9parer des paquets cadeaux personnalis\xe9s avec du papier et des rubans originaux",
    "Faire un puzzle de No\xebl en famille",
    "Acheter un ticket \xe0 gratter (sp\xe9cial No\xebl)",
    "Organiser un \xe9change de cadeaux 'Secret Santa'",
    "Participer \xe0 une collecte de jouets",
    "R\xe9server ou aller voir un spectacle de No\xebl",
    "Fabriquer des couronnes de No\xebl avec des branches et des d\xe9corations naturelles",
    "Faire du patin \xe0 glace dans une patinoire ext\xe9rieure ou int\xe9rieure",
    "Aller voir un film au cin\xe9ma",
    "Pr\xe9parer et distribuer des biscuits faits maison aux voisins",
    "Faire une soir\xe9e conte de No\xebl en racontant des histoires autour du feu ou sous un plaid",
    "Organiser un repas th\xe9matique de No\xebl avec des plats traditionnels",
    "Faire une session photo d\xe9guis\xe9e en lutins ou en rennes",
    "Assister \xe0 une messe ou \xe0 un concert de chants de No\xebl",
    "Aller visiter un march\xe9 de No\xebl",
    "Cr\xe9er un scrapbook ou un album photo des f\xeates de No\xebl"
];
const moviesListFR = [
    "La Reine des Neiges",
    "Klaus (ou aussi connu sous le titre 'La L\xe9gende de Klaus')",
    "Maman, j'ai rat\xe9 l'avion",
    "Le bonhomme de neige (The Snowman)",
    "Love Actually",
    "The Holiday",
    "Le lutin (Elf)",
    "L'\xe9trange No\xebl de Mr. Jack",
    "Les chroniques de No\xebl",
    "Le Grinch",
    "No\xebl chez les Muppets",
    "La Belle et la B\xeate: Un No\xebl enchant\xe9",
    "La magie de No\xebl (The Family Stone)",
    "Le No\xebl de Mickey",
    "Le Dr\xf4le de No\xebl de Scrooge",
    "La L\xe9gende de Manolo",
    "La princesse des glaces",
    "Le Manoir magique",
    "L'\xe9toile de No\xebl",
    "La bataille g\xe9ante de boules de neige",
    "Petit Vampire",
    "Le voyage du P\xe8re No\xebl",
    "Coco",
    "Miracle sur la 34e rue",
    "La course au jouet"
];
const craftsListFR = [
    "Fabriquer des d\xe9corations en papier pour le sapin de No\xebl",
    "Cr\xe9er des cartes de vœux personnalis\xe9es \xe0 envoyer \xe0 la famille et aux amis",
    "Confectionner des ornements en p\xe2te \xe0 sel pour d\xe9corer la maison",
    "Ecrire le menu de No\xebl",
    "Fabriquer des bougies parfum\xe9es pour cr\xe9er une ambiance chaleureuse",
    "Cr\xe9er un calendrier de l'avent fait maison avec des petites bo\xeetes ou pochettes",
    "Confectionner des couronnes de No\xebl avec des branches, des baies et des rubans",
    "Peindre des cailloux pour en faire des petits personnages de No\xebl",
    "Fabriquer des marionnettes de doigts pour raconter des histoires de No\xebl",
    "R\xe9aliser des \xe9toiles en papier pour suspendre dans la maison",
    "Cr\xe9er des flocons de neige en papier pour une d\xe9coration murale",
    "Fabriquer des masques de rennes ou de lutins pour jouer \xe0 se d\xe9guiser",
    "Confectionner des chaussettes de No\xebl en feutrine et les d\xe9corer",
    "Cr\xe9er des d\xe9corations en origami pour le sapin ou pour suspendre",
    "Fabriquer des magnets de No\xebl avec des aimants et des images festives",
    "R\xe9aliser des lanternes de No\xebl avec des pots de verre et des bougies LED",
    "Cr\xe9er des marque-places pour la table de f\xeate",
    "Confectionner des bonhommes de neige avec des chaussettes et du riz",
    "Fabriquer des couronnes de pommes de pin et les d\xe9corer",
    "Faire des oranges s\xe9ch\xe9es au four pour d\xe9corer la maison",
    "Confectionner des bonhommes en pain d'\xe9pices en carton d\xe9coratif",
    "Fabriquer des d\xe9corations en feutrine \xe0 accrocher dans la maison",
    "R\xe9aliser des boules de No\xebl personnalis\xe9es avec des photos ou des paillettes",
    "Cr\xe9er des petits villages en carton pour une sc\xe8ne de No\xebl",
    "Fabriquer des cadeaux DIY pour offrir \xe0 ses proches (bougies, baumes \xe0 l\xe8vres, etc.)"
];
const hyggeListFR = [
    "Pr\xe9parer du th\xe9 ou du chocolat chaud et le d\xe9guster en profitant d'un bon livre",
    "Cr\xe9er un coin confortable avec des coussins, des couvertures et des bougies pour une soir\xe9e cocooning",
    "Faire une promenade en for\xeat ou dans un parc pour profiter de la nature hivernale",
    "Cuisiner un plat r\xe9confortant et convivial \xe0 partager en famille ou entre amis",
    "Faire une s\xe9ance de m\xe9ditation ou de yoga pour se d\xe9tendre et se recentrer",
    "Faire une photo de famille devant le sapin, accessoires et d\xe9guisements optionnels ou bienvenus",
    "Organiser un apr\xe8s-midi de jeux de soci\xe9t\xe9 pr\xe8s du feu ou \xe0 la lueur des bougies",
    "Confectionner des d\xe9corations de No\xebl faites maison pour ajouter une touche personnelle \xe0 votre int\xe9rieur",
    "Prendre un bain relaxant avec des sels de bain parfum\xe9s et de la musique douce",
    "Pr\xe9parer un plateau de d\xe9gustation de biscuits faits maison pour partager avec des proches",
    "Allumer des bougies parfum\xe9es et \xe9couter de la musique apaisante pour cr\xe9er une ambiance chaleureuse",
    "Cr\xe9er une liste de gratitude pour r\xe9fl\xe9chir aux petites joies de la saison",
    "Fabriquer des cadeaux faits main pour offrir \xe0 vos proches",
    "Regarder les 'fails de No\xebl’ sur Youtube pour rigoler",
    "\xc9crire des lettres \xe0 des amis ou \xe0 la famille",
    "Faire une s\xe9ance de peinture ou de coloriage relaxante pour lib\xe9rer sa cr\xe9ativit\xe9",
    "Pr\xe9parer un brunch copieux et profiter d'un moment de convivialit\xe9 en famille",
    "Faire une s\xe9ance de relaxation avec des exercices de respiration et de stretching",
    "\xc9couter un podcast ou une \xe9mission relaxante tout en s'occupant d'une activit\xe9 manuelle",
    "Organiser un pique-nique int\xe9rieur avec des coussins et des couvertures douillettes",
    "Regarder un film ou une s\xe9rie douillette en famille ou en solo",
    "Faire une pause dans la journ\xe9e pour d\xe9guster une tasse de th\xe9 ou de caf\xe9 en pleine conscience",
    "Cr\xe9er une playlist de musique apaisante pour accompagner vos moments de d\xe9tente",
    "Faire un tour dans le quartier pour admirer les d\xe9corations lumineuses de No\xebl",
    "Passer du temps de qualit\xe9 avec vos proches, en partageant des moments simples mais pr\xe9cieux"
];

;// CONCATENATED MODULE: ./data/data.ts


const categories = [
    // display on preferences page and use for logic
    {
        en: "Craft & Create",
        fr: "Travaux Manuels",
        emoji: "\uD83E\uDDF6"
    },
    {
        en: "Kitchen",
        fr: "Dans la cuisine",
        emoji: "\uD83C\uDF6A"
    },
    {
        en: "Outings",
        fr: "Sorties",
        emoji: "\uD83D\uDC6A"
    },
    {
        en: "Hygge",
        fr: "Hygge",
        emoji: "\uD83C\uDF81"
    },
    {
        en: "Christmas Movies",
        fr: "Films de No\xebl",
        emoji: "\uD83C\uDF7F"
    }
];
const getEmoji = (category)=>{
    const cat = categories.find((i)=>i.en === category || i.fr === category);
    return cat === null || cat === void 0 ? void 0 : cat.emoji;
};
const getCategoryList = (val, locale)=>{
    if (locale === "fr") {
        switch(val){
            case "Kitchen":
                return kitchenListFR;
            case "Outings":
                return outingsListFR;
            case "Christmas Movies":
                return moviesListFR;
            case "Craft & Create":
                return craftsListFR;
            case "Hygge":
                return hyggeListFR;
            default:
                return [];
        }
    } else {
        switch(val){
            case "Kitchen":
                return kitchenList;
            case "Outings":
                return outingsList;
            case "Christmas Movies":
                return moviesList;
            case "Craft & Create":
                return craftsList;
            case "Hygge":
                return hyggeList;
            default:
                return [];
        }
    }
};
const getItemsFromCategory = (category, locale)=>{
    const categoryList = getCategoryList(category, locale);
    if (categoryList === null || categoryList === void 0 ? void 0 : categoryList.length) {
        let newCategory = category;
        const cat = categories.find((i)=>i.en === category);
        if (locale === "fr") {
            // get french category
            newCategory = (cat === null || cat === void 0 ? void 0 : cat.fr) || "";
        }
        return categoryList.map((i)=>{
            const container = {
                text: i,
                category: newCategory
            }; // display on :id page
            return container;
        });
    } else {
        return [];
    }
};


/***/ }),

/***/ 3230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js + 3 modules
var index_esm = __webpack_require__(4902);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/spinner/dist/index.esm.js
var dist_index_esm = __webpack_require__(5610);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__(7741);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/index.esm.js
var icons_dist_index_esm = __webpack_require__(3382);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-local-storage/use-local-storage.js + 2 modules
var use_local_storage = __webpack_require__(1509);
// EXTERNAL MODULE: ./node_modules/@lottiefiles/react-lottie-player/dist/lottie-react.esm.js
var lottie_react_esm = __webpack_require__(9879);
// EXTERNAL MODULE: ./data/data.ts + 2 modules
var data = __webpack_require__(8234);
;// CONCATENATED MODULE: ./features/main/components/DayItem.tsx







const DayItem = (param)=>{
    let { itemDay , currentDay  } = param;
    const router = (0,next_router.useRouter)();
    const [event] = (0,use_local_storage/* useLocalStorage */._)({
        key: "".concat(itemDay)
    });
    const playerRef = (0,react.useRef)(null);
    const isLookedAt = !!localStorage.getItem(itemDay.toString());
    const emptyTree = "https://assets9.lottiefiles.com/packages/lf20_ktwecrhe.json";
    const filledTree = "https://assets9.lottiefiles.com/packages/lf20_kenffpot.json";
    const calendarTree = "https://assets1.lottiefiles.com/packages/lf20_kc6glnpx.json";
    const handleClick = ()=>{
        if (currentDay >= itemDay) router.push("/".concat(itemDay));
    };
    const animation = ()=>{
        switch(true){
            case itemDay === 25:
                return calendarTree;
            case currentDay < itemDay:
                return emptyTree;
            case currentDay >= itemDay:
                return filledTree;
            case currentDay === itemDay:
                return filledTree;
            default:
                return filledTree;
        }
    };
    const isDisabled = ()=>{
        switch(true){
            case currentDay > itemDay:
                return false;
            case currentDay < itemDay:
                return true;
            case currentDay === itemDay:
                return false;
            default:
                return false;
        }
    };
    const textAndBorderColor = ()=>{
        switch(true){
            case isLookedAt:
                return "white";
            case currentDay > itemDay:
                return "gray.500";
            case currentDay < itemDay:
                return "gray.900";
            default:
                return "white";
        }
    };
    const cardBackgroundColor = ()=>{
        switch(true){
            case isLookedAt:
                return "green.600";
            case currentDay > itemDay:
                return "gray.600";
            case currentDay < itemDay:
                return "red.400";
            default:
                return "green.600";
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
        onClick: handleClick,
        border: "2px",
        alignItems: "center",
        justifyContent: "center",
        borderColor: textAndBorderColor(),
        borderRadius: 16,
        pb: [
            1,
            2
        ],
        flexDirection: "column",
        backgroundColor: cardBackgroundColor(),
        minHeight: "6rem",
        cursor: isDisabled() ? "not-allowed" : "pointer",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
            position: "relative",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                    minHeight: "5rem",
                    style: {
                        aspectRatio: 1 / 1
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lottie_react_esm/* Player */.J5, {
                        src: animation(),
                        className: "player",
                        keepLastFrame: true,
                        autoplay: currentDay === itemDay,
                        loop: true,
                        ref: playerRef,
                        style: {
                            opacity: currentDay > itemDay ? "50%" : ""
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Heading */.X6, {
                    size: "xl",
                    lineHeight: 0.8,
                    color: textAndBorderColor(),
                    textAlign: "center",
                    children: [
                        itemDay !== 25 ? itemDay.toString() : null,
                        " "
                    ]
                }),
                currentDay >= itemDay && event.category ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                    fontSize: "xs",
                    position: "absolute",
                    top: 2,
                    right: 2,
                    filter: currentDay === itemDay ? undefined : "grayscale(0.5)",
                    children: (0,data/* getEmoji */.gx)(event.category)
                }) : null
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@chakra-ui/hooks/dist/index.esm.js
var hooks_dist_index_esm = __webpack_require__(9653);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/index.esm.js + 57 modules
var modal_dist_index_esm = __webpack_require__(8965);
// EXTERNAL MODULE: ./node_modules/use-intl/dist/react/use-intl.esm2.js + 21 modules
var use_intl_esm2 = __webpack_require__(5270);
;// CONCATENATED MODULE: ./features/main/components/Info.tsx





const Info = ()=>{
    const { isOpen , onOpen , onClose  } = (0,hooks_dist_index_esm/* useDisclosure */.qY)();
    const cancelRef = (0,react.useRef)(null);
    const t = (0,use_intl_esm2/* default */.Z)("Info");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* IconButton */.hU, {
                onClick: onOpen,
                "aria-label": "info",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_dist_index_esm/* InfoOutlineIcon */.hQ, {
                    w: 8,
                    h: 8
                }),
                position: "fixed",
                bottom: "30",
                right: "30",
                colorScheme: "transparent"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* AlertDialog */.aR, {
                motionPreset: "slideInBottom",
                leastDestructiveRef: cancelRef,
                onClose: onClose,
                isOpen: isOpen,
                isCentered: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* AlertDialogOverlay */.dh, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* AlertDialogContent */._T, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* AlertDialogHeader */.fY, {
                                children: t("title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* AlertDialogCloseButton */.lq, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* AlertDialogBody */.iP, {
                                children: t("body")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* AlertDialogFooter */.xo, {})
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./features/main/index.ts



// EXTERNAL MODULE: ./components/Header.tsx
var Header = __webpack_require__(3505);
;// CONCATENATED MODULE: ./features/countdown/components/Countdown.tsx




let today = new Date();
let christmasYear = today.getFullYear();
if (today.getMonth() == 11 && today.getDate() > 1) {
    christmasYear = christmasYear + 1;
}
let christmasDate = new Date(christmasYear, 11, 1);
let dayMilliseconds = 1000 * 60 * 60 * 24;
let remainingDays = Math.ceil((christmasDate.getTime() - today.getTime()) / dayMilliseconds);
const Countdown = ()=>{
    const t = (0,use_intl_esm2/* default */.Z)("Countdown");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Center */.M5, {
        h: "100vh",
        flexDirection: "column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                position: "relative",
                textAlign: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(lottie_react_esm/* Player */.J5, {
                        src: "https://assets3.lottiefiles.com/packages/lf20_i7y3y8fi.json",
                        className: "player",
                        autoplay: true,
                        loop: true,
                        style: {
                            height: "256px",
                            width: "256px"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                        mt: 4,
                        color: "white",
                        fontSize: "2xl",
                        position: "absolute",
                        top: "34%",
                        right: "46%",
                        children: remainingDays
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                mt: 4,
                color: "white",
                fontSize: "2xl",
                children: [
                    t("day"),
                    remainingDays > 1 && "s",
                    " ",
                    t("december")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                mt: 4,
                color: "white",
                fontSize: "md",
                children: t("body")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./features/countdown/index.ts


;// CONCATENATED MODULE: ./pages/index.tsx










var __N_SSG = true;
function Home() {
    const router = (0,next_router.useRouter)();
    const [currentDay, setCurrentDay] = (0,react.useState)(0);
    const [isDecember, setIsDecember] = (0,react.useState)(false);
    const [isLoading, setIsLoading] = (0,react.useState)(true);
    const [value] = (0,use_local_storage/* useLocalStorage */._)({
        key: "categories",
        defaultValue: undefined
    });
    const [daysArray] = (0,use_local_storage/* useLocalStorage */._)({
        key: "daysArray",
        defaultValue: undefined
    });
    const getCurrentDay = ()=>{
        const date = new Date();
        const day = date.getDate();
        setCurrentDay(day);
        const intervalId = setInterval(()=>{
            setCurrentDay(day);
        }, 60000);
        return intervalId;
    };
    (0,react.useEffect)(()=>{
        setIsLoading(true);
        const d = new Date();
        const currentMonth = d.getMonth();
        currentMonth === 11 ? setIsDecember(true) : setIsDecember(false);
        if (localStorage.getItem("categories") === null || localStorage.getItem("daysArray") === null || localStorage.getItem("currentMonth") !== "".concat(currentMonth) || typeof value === "object" && value.length === 0) router.push("/preferences");
        const intervalId = getCurrentDay();
        setTimeout(()=>{
            setIsLoading(false);
        }, 500);
        return ()=>{
            clearInterval(intervalId);
        };
    }, [
        router,
        value
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                    h: "100vh",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Spinner */.$, {
                        thickness: "4px",
                        speed: "1s",
                        emptyColor: "gray.600",
                        color: "white",
                        size: "xl"
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: isDecember ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                            maxW: "4xl",
                            pt: [
                                2,
                                8,
                                16,
                                24
                            ],
                            px: [
                                2,
                                8,
                                16,
                                24
                            ],
                            mb: 24,
                            children: daysArray && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SimpleGrid */.MI, {
                                columns: [
                                    4,
                                    5,
                                    6
                                ],
                                spacingX: [
                                    1,
                                    2,
                                    4
                                ],
                                spacingY: [
                                    1,
                                    2,
                                    4
                                ],
                                children: daysArray.map((day, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(DayItem, {
                                        itemDay: day,
                                        currentDay: currentDay
                                    }, i))
                            })
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Countdown, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* IconButton */.hU, {
                as: (link_default()),
                href: "/preferences",
                "aria-label": "preferences",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_dist_index_esm/* SettingsIcon */.ew, {
                    w: 8,
                    h: 8
                }),
                position: "fixed",
                bottom: "30",
                left: "30",
                colorScheme: "transparent"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Info, {})
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [388,573,270,868,774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);